import { gql } from '@apollo/client'

export const GET_STORE_CHAINS = gql`
  query GetStoreChains($input: StoreChainInput!) {
    storeChains(input: $input) {
      count
      hasMore
      results {
        id
        name
      }
    }
  }
`
